import { render, staticRenderFns } from "./AnswerImage.vue?vue&type=template&id=73051e8a&scoped=true"
import script from "./AnswerImage.vue?vue&type=script&lang=js"
export * from "./AnswerImage.vue?vue&type=script&lang=js"
import style0 from "./AnswerImage.vue?vue&type=style&index=0&id=73051e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73051e8a",
  null
  
)

export default component.exports